module.exports = __webpack_public_path__ + "static/media/vendor_default.cb2c0786.svg";